import { useEffect, useState } from "react";

declare global {
  interface Window {
    $crisp: unknown[];
    CRISP_WEBSITE_ID: string;
    tolt_referral?: string;
  }
}

export const useCrispChat = (): {
  toggleChat: () => void;
  isChatOpen: boolean;
} => {
  const [isChatOpen, setIsChatOpen] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.$crisp = [];
      window.CRISP_WEBSITE_ID = "39c997e6-322f-4b80-806a-79e23de8a606";

      const script = document.createElement("script");
      script.src = "https://client.crisp.chat/l.js";
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        window.$crisp.push(["on", "chat:opened", () => setIsChatOpen(true)]);
        window.$crisp.push(["on", "chat:closed", () => setIsChatOpen(false)]);

        // Hide the default Crisp button
        window.$crisp.push(["do", "chat:hide"]);

        // Configure Crisp to not show the default button
        window.$crisp.push(["config", "hide_vacation", true]);
        window.$crisp.push(["config", "hide_on_away", true]);
        window.$crisp.push(["config", "hide_on_mobile", true]);
      };
    }
  }, []);

  const toggleChat = (): void => {
    if (typeof window !== "undefined" && window.$crisp) {
      if (isChatOpen) {
        window.$crisp.push(["do", "chat:close"]);
      } else {
        window.$crisp.push(["do", "chat:open"]);
        window.$crisp.push(["do", "chat:show"]); // Ensure the chat is visible when opened
      }
      setIsChatOpen(!isChatOpen);
    }
  };

  return { toggleChat, isChatOpen };
};
